// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"1831850d","2314":"3b45534f","7280":"39c1f9dc"}[chunkId] + ".chunk.css";
};